export enum DISPLAY_TYPE {
    Text,
    Date,
    CustomText,
}